import React, { FC, useEffect } from "react";
import { Col, Row, List, Spin } from "antd";
import { Link } from "react-router-dom";
import IndexChart from "../FearGreed/IndexChart";
// import HistoricalIndexChart from "../FearGreed/HistoricalIndexChart";
import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import { IResultResponse } from "../../models/response/result.model";
import MarketDominanceChart from "../FearGreed/MarketDominanceChart";
import MomentumChart from "../FearGreed/MomentumChart";
import MarketVolumesChart from "../FearGreed/MarketVolumesChart";
import VolatilityChart from "../FearGreed/VolatilityChart";
import CommonService from "../../services/common.service";
import moment from "moment";

interface ILabel {
  name: string;
  label: string;
  render?: () => string | React.ReactNode;
}

const FearAndGreedIndex: FC = () => {
  useEffect(() => {
  }, []);

  const { fetchedData: summary, loading } = useHttpGet<IResultResponse<{}>>(
    `${APIRoutes.FEAR_AND_GREED}/summary`,
    {
      defaultValue: { result: {} as any },
    }
  );

  const labels: ILabel[] = [
    {
      name: "update",
      label: "Last updated",
      render: () => moment(getValue('today').date).format('MM/DD/YYYY hh:mm')
    },
    {
      name: "nextUpdate",
      label: "Next update",
      render: () => moment(getValue('today').date).add(1, 'd').format('MM/DD/YYYY hh:mm')
    },
    {
      name: "yesterday",
      label: "Yesterday",
      render: () => Math.round(getValue('yesterday').value)
    },
    {
      name: "lastWeek",
      label: "Last Week",
      render: () => Math.round(getValue("lastWeek").value),
    },
    {
      name: "lastMonth",
      label: "Last Month",
      render: () => Math.round(getValue("lastMonth").value),
    },
    {
      name: "",
      label: "",
      render: () => (
        <Link
          to={`/pages/Fear-and-Greed-Index-Methodology/21`}
        >
          Index Methodology
        </Link>
      ),
    }
  ];

  const getValue = (name: string) => CommonService.getProperty(summary.result, name);

  return (
    <Spin spinning={loading}>
      <Row justify="center" align="top">
        <Col xs={24} sm={22} md={22}>
          <Row align="top">
            <Col xs={24} sm={12} md={12}>
              <IndexChart />
            </Col>

            <Col xs={24} sm={12} md={12}>
              <List
                dataSource={summary?.result ? labels : []}
                renderItem={(item: ILabel) => (
                  <List.Item>
                    <div className="d-flex align-items-center justify-content-between w-100">
                      <span>{item.label}</span>
                      <span>
                        {item?.render && item.render()}
                      </span>
                    </div>
                  </List.Item>
                )}
              />
            </Col>
          </Row>

          {/* 
          <Col xs={24} sm={18} md={20}>
              <HistoricalIndexChart />
            </Col> 
            */}

          <Row align="top">
            <Col xs={24} sm={18} md={20}>
              <h2>Bitcoin Market Dominance</h2>
              <MarketDominanceChart />
            </Col>

            <Col xs={24} sm={18} md={20}>
              <h2>Market Momentum</h2>
              <MomentumChart />
            </Col>

            <Col xs={24} sm={18} md={20}>
              <h2>Market Volume</h2>
              <MarketVolumesChart />
            </Col>

            <Col xs={24} sm={18} md={20}>
              <h2>Volatility</h2>
              <VolatilityChart />
            </Col>
          </Row>
        </Col>
      </Row>
    </Spin>
  );
};

export default FearAndGreedIndex;
